import type { ReactNode } from 'react';

export const symbol_smb_share: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M457-430h181q24.32 0 41.16-16.77 16.84-16.78 16.84-41 0-24.23-16.84-41.73Q662.32-547 638-547h-12l-2-10q-4-31-27.78-52-23.77-21-56.46-21Q514-630 492-617q-22 13-30 36l-2 7h-8q-29 0-48.5 21.5T384-502.14q0 28.85 21.5 50.5Q427-430 457-430ZM100-120q-24 0-42-18t-18-42v-540q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v540h700q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H100Zm120-120q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h235q12.44 0 23.72 5t19.37 13.09L540-820h320q24 0 42 18t18 42v460q0 24-18 42t-42 18H220Zm0-60h640v-460H515l-60-60H220v520Zm0 0v-520 520Z"
		/>
	</svg>
);
